import React, { useEffect } from 'react'
import LiveAds from '../LiveAds/LiveAds'
import { useLocation } from 'react-router-dom';

const LiveAds_wrap = () => {
  document.title = "Live Ads" 
  const { pathname } = useLocation();
  useEffect(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);
  return (
    <>
        <LiveAds version="Detail"></LiveAds>
    </>
  )
}

export default LiveAds_wrap